//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DivSpan from '@/components/DivSpan'

export default {
  name: "cell-collapse",
  data() {
    return {

    }
  },
  props:['title','cellValue','show','icon','unitDivSpan','unitDivSpanTitle'],
  components: {
    DivSpan
  },
  methods: {

  },



}



// WEBPACK FOOTER //
// ./src/components/cell-collapse.vue